export const allCards = [
  {
    id: Math.floor(Math.random() * Date.now()),
    nome: "Natalie Lee-Walsh",
    descricao: "Curabitur elementum felis a tellus maximus cursus.",
    ataque: 1,
    defesa: 10,
    tipo: "criatura",
    classe: "mago",
  },
  {
    id: Math.floor(Math.random() * Date.now()),
    nome: "Trevor Virtue",
    descricao: "Ut maximus ligula at magna hendrerit auctor.",
    ataque: 2,
    defesa: 5,
    tipo: "magia",
    classe: "paladino",
  },
  {
    id: Math.floor(Math.random() * Date.now()),
    nome: "Natalie Lee-Walsh",
    descricao: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    ataque: 3,
    defesa: 10,
    tipo: "magia",
    classe: "caçador",
  },
  {
    id: Math.floor(Math.random() * Date.now()),
    nome: "John Stone",
    descricao:
      "Quisque sit amet diam ac lacus bibendum scelerisque at quis urna.",
    ataque: 10,
    defesa: 7,
    tipo: "criatura",
    classe: "druida",
  },
  {
    id: Math.floor(Math.random() * Date.now()),
    nome: "Salome Simoes",
    descricao:
      "Etiam ut dui consequat, auctor lectus vulputate, luctus lectus.",
    ataque: 3,
    defesa: 7,
    tipo: "magia",
    classe: "qualquer",
  },
  {
    id: Math.floor(Math.random() * Date.now()),
    nome: "Tamzyn French",
    descricao:
      "Etiam ut dui consequat, auctor lectus vulputate, luctus lectus.",
    ataque: 2,
    defesa: 6,
    tipo: "criatura",
    classe: "druida",
  },
  {
    id: Math.floor(Math.random() * Date.now()),
    nome: "Natalie Lee-Walsh",
    descricao: "Nullam at felis ac nisl aliquet congue eget in erat.",
    ataque: 2,
    defesa: 4,
    tipo: "magia",
    classe: "paladino",
  },
  {
    id: Math.floor(Math.random() * Date.now()),
    nome: "Tamzyn French",
    descricao:
      "Donec eleifend risus non turpis fermentum, ut venenatis turpis mollis.",
    ataque: 5,
    defesa: 10,
    tipo: "magia",
    classe: "caçador",
  },
  {
    id: Math.floor(Math.random() * Date.now()),
    nome: "John Stone",
    descricao:
      "Etiam ut dui consequat, auctor lectus vulputate, luctus lectus.",
    ataque: 2,
    defesa: 4,
    tipo: "criatura",
    classe: "qualquer",
  },
  {
    id: Math.floor(Math.random() * Date.now()),
    nome: "Nguta Ithya",
    descricao:
      "Etiam ut dui consequat, auctor lectus vulputate, luctus lectus.",
    ataque: 3,
    defesa: 10,
    tipo: "magia",
    classe: "qualquer",
  },
];
